import React from 'react'
import Header from './components/Head/Header'
import './App.css';
import Home from './components/Hero/Home';
import Features from './components/Features/Features';
//testing
const App = () => {
  return (
    <div>
      <Header/>

      <Home/>
      
      <Features/>
    </div>
  )
}

export default App
